window.addEventListener('load', () => {
  // copy footer into menu
  const footer = document.getElementById('morobe-footer-wrapper');
  const footerCopy = footer.cloneNode(true);
  // rearange divs, place last one at the front
  const footerCopyChildren = footerCopy.children[0].children;

  const lastChild = footerCopyChildren[footerCopyChildren.length - 1];
  footerCopyChildren[footerCopyChildren.length - 1].remove();
  // place lastChild at the front
  footerCopy.children[0].insertBefore(lastChild, footerCopy.children[0].firstChild);
  const menu = document.getElementById('morobe-menu');
  menu.appendChild(footerCopy);

  // reveil the menu (we hide it in css to prevent flickering)
  document.querySelector('#morobe-menu').style.opacity = 1;
});

document.getElementById('openMenuButton')?.addEventListener('click', (e) => {
  const menu = document.querySelector('#morobe-menu');
  menu.classList.toggle('open');

  if (window.onlyShowShopLink) {
    if (menu.classList.contains('open')) {
      // document.querySelector(' #MainContent').style.marginLeft = 'var(--morobe-nav-width)';
    } else {
      //    document.querySelector(' #MainContent').style.marginLeft = '0';
    }
  }
});

// detect click outside of menu when its open
if (window.onlyShowShopLink) {
  document.addEventListener('click', (e) => {
    const menu = document.querySelector('#morobe-menu');
    if (menu.classList.contains('open')) {
      if (!menu.contains(e.target)) {
        menu.classList.remove('open');
        e.preventDefault();
      }
    }
  });
}

document.getElementById('closeMenuButtonDesktop')?.addEventListener('click', (e) => {
  const menu = document.querySelector('#morobe-menu');
  menu.classList.remove('open');
});

document.querySelectorAll('button.subLinkie').forEach((btn) => {
  btn.addEventListener('click', (e) => {
    // check if btn siblings have openMenu class
    // button is in li then in ul, so go up 2 levels
    const sibblingss = Array.from(btn.parentElement.parentElement.children);

    sibblingss.forEach((sibling) => {
      if (sibling !== btn.parentElement) {
        // check if sibling has a child element with openmenu class
        const openMenu = sibling.querySelector('.openMenu');
        if (openMenu) {
          openMenu.classList.remove('openMenu');
        }
      }
    });

    // check parent parent parent to see if its a parentLinkie;
    const parentLinkie = btn.parentElement.parentElement.parentElement;
    if (parentLinkie.classList.contains('parentLinkie')) {
      const numberOfLinkies = parseInt(getComputedStyle(parentLinkie).getPropertyValue('--numberOfLinkies'));

      const numberOfChildren = btn.parentElement.querySelectorAll('li').length;
    //  console.log('👩‍👦', parentLinkie, numberOfChildren, numberOfLinkies);
      if (btn.classList.contains('openMenu')) {
        parentLinkie.style.setProperty('--numberOfLinkies', numberOfLinkies - numberOfChildren);
      } else {
        parentLinkie.style.setProperty('--numberOfLinkies', numberOfLinkies + numberOfChildren);
      }
    }
    btn.classList.toggle('openMenu');
  });
});

// check if we have a href a with same url as the location.href
const currentLinkFromUrl = location.pathname + location.search;
let currentLink = document.querySelector(`a[href="${currentLinkFromUrl}"]`);
if (currentLink == null) {
  currentLink = document.querySelector(`a[href="https://www.morobe.com${currentLinkFromUrl}"]`);
}
console.log("current LINKK 😀", currentLink)
if (currentLink && currentLinkFromUrl != '/') {
  currentLink.classList.add('active');
 const parentOfActive = currentLink.parentElement.parentElement.previousElementSibling;
 parentOfActive.classList.add('openMenu');

// if we have nested links, we need to open also the top parent
if(parentOfActive.classList.contains('subLinkie')){
  const parentParentOfActive = parentOfActive.parentElement.parentElement.previousElementSibling;
  if(parentParentOfActive){
    parentParentOfActive.classList.add('openMenu');
  }

}

  // get numberOfLinkies
  const parentLinkie = currentLink.parentElement.parentElement.parentElement;

  // now add these to the parentParentLinkie;
  const parentParentLinkie = parentLinkie.parentElement.parentElement;
  if (parentParentLinkie.classList.contains('parentLinkie')) {
    const numberOfLinkies = parseInt(getComputedStyle(parentLinkie).getPropertyValue('--numberOfLinkies'));
    const numberOfLinkiesParent = parseInt(getComputedStyle(parentParentLinkie).getPropertyValue('--numberOfLinkies'));

    parentParentLinkie.style.setProperty('--numberOfLinkies', numberOfLinkiesParent + numberOfLinkies);
  }
}
const linkiewithOpenMenu = document.querySelector('.openMenu');

if (linkiewithOpenMenu) {
} else {
  // check if no active link

  const activeLink = document.querySelector('.morobe-menu .active');
  if (!activeLink) {
    document.querySelector('.subLinkie.womenlink').classList.add('openMenu');
    document.querySelector('.subLinkie.womenlink').classList.add('active');
  }
}
